import { legacyColors } from '~/legacyTheme';
import { theme } from '~/theme';

const colors = {
  tab: {
    background: {
      default: legacyColors.grey2,
      disabled: legacyColors.grey2,
      active: legacyColors.white,
    },
    border: legacyColors.grey2,
    topBorder: {
      default: legacyColors.grey2,
      summary: legacyColors.grey6,
      disabled: legacyColors.grey2,
      active: legacyColors.blue,
    },
    text: {
      default: legacyColors.text.default,
      disabled: legacyColors.text.default,
      active: legacyColors.text.highlight,
    },
  },
};

export const useSxStyles = () => {
  return {
    root: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto 1fr',
      minHeight: '100%',
    },
    content: {
      padding: theme.spacing(1.5, 2),
      backgroundColor: colors.tab.background.active,
    },
    tabLabelWrapper: {
      display: 'flex',
    },
    tabHelpButton: {
      margin: theme.spacing(-1.5, -2, -1.5, 0),
    },
  };
};
